import React from "react";

export default class Loader extends React.Component {
  render() {
    return (
      <div
        style={{
          position: "fixed",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          backgroundColor: "white",
          zIndex: "99999"
        }}
      >
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50px",
            height: "50px"
          }}
          className="ui active centered inline text loader"
        >
          {this.props.text || ""}
        </div>
      </div>
    );
  }
}
